import React, { useEffect, useState } from "react";
import { assets } from "../../../Assets/assets";
import { Link } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const PhoneStep = ({
  phone,
  setPhone,
  agreed,
  setAgreed,
  loadingAction,
  onGetOtp,
  setCountryCode,
  countryCode,
  selectedRole = "buyer",
  setSelectedRole,
}) => {
  const [focused, setFocused] = useState(false);
  const [touched, setTouched] = useState(false);
  const [current, setCurrent] = useState(0);
  const [progress, setProgress] = useState(0);
  const active = focused || phone.length > 0 || touched;

  const images = [
    assets.loginvectormobile,
    assets.loginvectormobile2,
    assets.loginvectormobile3,
  ];

  useEffect(() => {
    const duration = 3000;
    const intervalTime = 50;

    const progressStep = 100 / (duration / intervalTime);

    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          setCurrent((c) => (c + 1) % images.length);
          return 0;
        }
        return prev + progressStep;
      });
    }, intervalTime);

    return () => clearInterval(interval);
  }, []);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();

        if (
          loadingAction !== "get-otp" &&
          phone.length === 10 &&
          agreed
        ) {
          onGetOtp();
        }
      }}
      className="flex flex-col justify-between flex-1 gap-5 h-full"
    >
      <div className="space-y-3">
        <div className="sm:hidden mt-20 flex flex-col items-center">

          {/* Image Container */}
          <div className="relative w-full h-96 overflow-hidden">
            {images.map((img, index) => (
              <img
                key={index}
                src={img}
                alt="step"
                className={`
          absolute top-0 left-0 w-full h-full object-contain
          transition-all duration-700 ease-in-out
          ${index === current ? "opacity-100 scale-100" : "opacity-0 scale-95"}
        `}
              />
            ))}
          </div>

          {/* Dots + Progress */}
          <div className="flex gap-2 mt-4">
            {images.map((_, index) => (
              <div
                key={index}
                className="w-6 h-1.5 bg-gray-200 rounded-full overflow-hidden"
              >
                <div
                  className="h-full bg-primaryColor transition-all duration-100"
                  style={{
                    width:
                      index === current
                        ? `${progress}%`
                        : index < current
                          ? "100%"
                          : "0%",
                  }}
                />
              </div>
            ))}
          </div>

        </div>

        <h1 className="text-xl text-primaryColor font-semibold text-center sm:text-left capitalize">
          Log In As {selectedRole === "supplier" ? "Supplier" : "Buyer"}
        </h1>
        {/* Float-label phone input */}
        <div className="relative">
          <label
            className={`
            absolute transition-all duration-200 pointer-events-none z-10 bg-white px-1
            ${active
                ? "-top-[0.5rem] text-xs text-primaryColor font-medium left-[3.8rem]"
                : "top-[1.2rem] text-sm text-gray-400 left-3"
              }
          `}
          >
            Enter Your Mobile Number
          </label>
          <div
            className={`
    flex items-center border-2 rounded-xl overflow-visible transition-all duration-200
    ${focused ? "border-primaryColor shadow-sm shadow-primaryColor/20" : "border-gray-200"}
  `}
          >
            <PhoneInput
              country={"in"}
              enableSearch
              value={`${countryCode.replace("+", "")}${phone}`}
              onChange={(value, data) => {
                setTouched(true);
                const dialCode = data.dialCode;
                const newCountryCode = "+" + dialCode;
                const newPhone = value.slice(dialCode.length);

                setCountryCode(newCountryCode);
                setPhone(newPhone.replace(/\D/g, "").slice(0, 10));
              }}
              onFocus={() => {
                setFocused(true);
                setTouched(true);
              }}
              onBlur={() => {
                if (document.querySelector(".country-list:hover")) return;
                setFocused(false);
              }}
              onClick={() => setTouched(true)}
              containerClass="phone-container"
              inputClass="phone-input"
              buttonClass="phone-flag-btn"

              inputProps={{
                onKeyDown: (e) => {
                  if (
                    e.key === "Enter" &&
                    phone.length === 10 &&
                    agreed &&
                    loadingAction !== "get-otp"
                  ) {
                    e.preventDefault();
                    onGetOtp();
                  }
                },
              }}
            />

            {phone.length === 10 && (
              <div className="pr-3 flex-shrink-0">
                <div className="w-5 h-5 rounded-full bg-green-500 flex items-center justify-center">
                  <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                </div>
              </div>
            )}
          </div>

          {phone.length > 0 && phone.length < 10 && (
            <p className="text-xs text-amber-500 mt-1.5 ml-1">{10 - phone.length} more digits needed</p>
          )}
        </div>

        {/* Terms & conditions checkbox */}
        <label className="flex items-start gap-3 group">
          <div className="relative mt-0.5 flex-shrink-0">
            <input
              type="checkbox"
              checked={agreed}
              onChange={() => setAgreed(!agreed)}
              className="sr-only"
            />
            <div
              className={`
              w-5 h-5 rounded-md border-2 flex items-center justify-center transition-all duration-200
              ${agreed
                  ? "bg-primaryColor border-primaryColor"
                  : "border-gray-300 bg-white group-hover:border-primaryColor/60"
                }
            `}
            >
              {agreed && (
                <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              )}
            </div>
          </div>
          <p className="text-xs text-gray-500 leading-relaxed">
            By continuing, I confirm that I agree to the{" "}
            <Link to="/terms-and-conditions" target="_blank" className="text-primaryColor hover:underline font-medium cursor-pointer">
              terms & conditions
            </Link>
            {" "}and{" "}
            <Link to="/privacy-policy" target="_blank" className="text-primaryColor hover:underline font-medium cursor-pointer">
              privacy policy
            </Link>
            , also receive communication via SMS, WhatsApp
          </p>
        </label>
      </div>

      {/* Get OTP button */}
      <button
        type="submit"
        disabled={
          loadingAction === "get-otp" ||
          phone.length < 10 ||
          !agreed
        }
        className="
          w-full bg-primaryColor text-white py-3.5 rounded-xl font-semibold text-sm
          hover:bg-primaryColor/90 active:scale-[0.98]
          transition-all duration-200
          disabled:opacity-40 disabled:cursor-not-allowed disabled:active:scale-100
          flex items-center justify-center gap-2 shadow-md shadow-primaryColor/30
        "
      >
        {loadingAction === "get-otp" ? (
          <>
            <svg className="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
            </svg>
            Sending OTP...
          </>
        ) : (
          <>
            Continue
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M13 7l5 5-5 5M6 12h12" />
            </svg>
          </>
        )}
      </button>
      <div className="text-center">
        <p className="text-xs text-gray-500">
          Are you an admin?{" "}
          <Link
            to="https://pcm-qqc-vl7p.vercel.app/"
            className="text-primaryColor font-semibold hover:underline"
          >
            Login here
          </Link>
        </p>
      </div>
    </form>

  );
};

export default PhoneStep;